// extracted by mini-css-extract-plugin
export default {"loadingWrap":"Loading_loadingWrap__cG08A"};